export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "使用教程",
    slug: "tutorial",
    icon: "ri-book-open-line",
    description: "JM网页版详细使用教程，从入门到精通，手把手教你使用JM平台的全部功能",
  },
  {
    id: "cat-2",
    name: "最新资讯",
    slug: "news",
    icon: "ri-newspaper-line",
    description: "JM平台最新动态、版本更新、官方公告，第一时间掌握最新信息",
  },
  {
    id: "cat-3",
    name: "常见问题",
    slug: "faq",
    icon: "ri-question-answer-line",
    description: "JM网页版常见问题解答，快速解决您在使用过程中遇到的各类问题",
  },
  {
    id: "cat-4",
    name: "安全指南",
    slug: "security",
    icon: "ri-shield-check-line",
    description: "JM网页版安全使用指南，保护您的账号安全与隐私，防范各类网络风险",
  },
  {
    id: "cat-5",
    name: "功能解析",
    slug: "features",
    icon: "ri-stack-line",
    description: "JM网页版功能深度解析，全面了解平台各项强大功能的使用技巧",
  },
];

export const categoryMap: Record<string, Category> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});